<template>
  <div>
    <div class="direct-chat">
      <div class="box-header">
        <h3 class="box-title"><i class="fa fa-calendar-o mr-5"></i>{{'store_history' | translate}}</h3>
      </div>
      <div class="box-body">
        <div class="direct-chat-messages">
          <ul class="timeline">
            <template v-for="t in transitions">
              <li class="time-label">
                <span><i class="fa fa-calendar-o mr-5"></i>{{t.date}}</span>
              </li>
              <li v-for="e in t.transitions">
                <i :class="[getClass(e.event).icon, getClass(e.event).style]"></i>
                <div class="timeline-item">
                  <div class="timeline-header">
                    <span class="text-muted"><i class="fa fa-clock-o mr-5"></i>{{e.time}}</span> <span :class="getClass(e.event).style">{{e.event | translate}}</span>
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['transitions', 'main'],
  data () {
    return {
      show: true,
      isLoading: false,
      alerts: []
    }
  },
  methods: {
    getClass (e) {
      switch (e) {
        case 'shipped':
          return {icon: 'fa fa-truck', style: 'text-success', btn: 'btn btn-success'}
        case 'initial':
          return {icon: 'fa fa-cloud-download', style: 'text-primary', btn: 'btn btn-primary'}
        case 'approved':
          return {icon: 'fa fa-thumbs-up', style: 'text-info', btn: 'btn btn-info'}
        case 'fulfilled':
          return {icon: 'fa fa-check', style: 'text-teal', btn: 'btn btn-info'}
        case 'cancelled':
        case 'canceled':
          return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
        case 'mp_cancellation':
          return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
        case 'returned':
          return {icon: 'fa fa-reply', style: 'text-warning', btn: 'btn btn-warning'}
      }
    },
    checkTransitionType (e) {
    	return e.event === 'fulfilled' || e.event === 'cancelled' || e.event === 'mp_cancellation'
    },
    rank (e) {
    	this.isLoading = true
	    this.$validator.validate()
		    .then(result => {
		    	if (result) {
				    API.put(`/orders/transition/${e.id}/rank`, {points: e.ranking.replace(',', '.'), message: e.message})
					    .then(response => {
						    this.isLoading = false
						    let alert = {type: 'success', dismiss: 4, message: 'update_successful'}
						    this.alerts.push(alert)
					    })
					    .catch(error => {
						    this.isLoading = false
						    let alert = {type: 'danger', dismiss: 4, message: 'update_error'}
						    this.alerts.push(alert)
					    })
			    } else {
		    		this.isLoading = false
          }
		    })
    }
  },
  watch: {
    transitions () {
    }
  }
}
</script>
<style scoped>
  .text-italics{
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/StoreHistory.vue